var FeatureModal = (function () {


  var $featureModal;
  var $svgClose;
  var $body;
  var interval;
  var spinner;

  function attachFetch() {
    $featureModal = $('.acr-feature-modal');
    $svgClose = $('.acr-icon.feature-modal-close');
    var $modalAnchors = $('[data-acr-feature-modal]');

    $modalAnchors.off('click', fetch)
      .on('click', fetch);
  }

  function fetch(e) {
    e.preventDefault();

    $featureModal.find('.feature-modal-window').html(spinner);
    $featureModal.addClass('visible');

    Utility.removeClassFromSvg($svgClose, 'hide');
    Utility.addClassToSvg($svgClose, 'hide');

    if (!$(this).hasClass('is-modal-content')) {
      $.get($(this).attr('href') + '?stub=1', function (data) {
        $featureModal.find('.animated-spinner').removeClass('visible');
        $featureModal.find('.feature-modal-window').html(data);

        if ($('html').hasClass('ie')) {
          setTimeout(waitImage, 400);
        } else {
          layout();
          Acr.Disclaimer.init();
        }

        attachModalDeeplinks();
      });
    } else {
      var modalContent = '<div class="acr-modal-page-container">'
        + '<div class="collapse-content">'
        + '<div class="header">'
        + '<h1 class="header-name acr-secondary-title-1">' + $(this).attr('data-title') + '</h5>'
        + '<svg id="close" class="acr-icon feature-modal-close" viewBox="0 0 211.7 200">'
        + '<g xmlns="http://www.w3.org/2000/svg">'
        + '<path d="M107,0C51.8,0,7,44.8,7,100s44.8,100,100,100s100-44.8,100-100S162.2,0,107,0z M107,192c-50.7,0-92-41.3-92-92   S56.3,8,107,8s92,41.3,92,92S157.7,192,107,192z"></path>'
        + '<polygon points="139.8,62.5 106.6,95.7 73.5,62.5 67.8,68.2 101,101.4 67.8,134.5 73.5,140.2 106.6,107 139.8,140.2 145.5,134.5   112.3,101.4 145.5,68.2  "></polygon>'
        + '</g>'
        + '</svg>'
        + '</div>'
        + '<div class="content-container">'
        + '<div class="content-media">'
        + '<picture class="content-media__picture content-media__picture--internal-js">'
        + '<img class="content-media__img" src="' + $(this).attr('data-image') + '">'
        + '</picture>'
        + '</div>'
        + '<div class="content">'
        + '<div class="content__description">'
        + '<div class="description acr-paragraph-5">'
        + $(this).attr('data-description')
        + '</div>'
        + '</div>'
        + '</div>'
        + '</div>'
        + '</div>'
        + '</div>';

      $featureModal.find('.feature-modal-window').html(modalContent);

      if ($('html').hasClass('ie')) {
        setTimeout(waitImage, 400);
      } else {
        layout();
        Acr.Disclaimer.init();
      }
    }
  }

  function attachClicks() {
    $(document).off('click',
      '.acr-feature-modal .acr-icon.feature-modal-close', closeHandler);
    $(document).on('click',
      '.acr-feature-modal .acr-icon.feature-modal-close', closeHandler);

    $(document).off('click',
      '.acr-feature-modal use', closeHandler);
    $(document).on('click',
      '.acr-feature-modal use', closeHandler);

    $featureModal.off('click', closeHandler)
      .on('click', closeHandler);

    $featureModal.find('.feature-modal-window')
      .off('click', stopPropagation)
      .on('click', stopPropagation);
  }

  function attachKeyboardInput() {
    $(document).off('keyup', keyboardHandler)
      .on('keyup', keyboardHandler);
  }

  function attachResize() {
    $(window).off('resize', layout);
    $(window).resize(layout);
  }

  function attachModalDeeplinks() {
    $featureModal.find('a[href*=#]').off('click', closeHandler);
    $featureModal.find('a[href*=#]').on('click', closeHandler);
  }

  function closeHandler() {
    // Enable scrolling.
    document.removeEventListener('touchmove', handleTouchLock);

    $featureModal.removeClass('visible');
    $body.removeClass('modal-open');
  }

  function stopPropagation(e) {
    var $target = $(e.target);
    if (!$target.is('svg') && !$target.is('use') && !$target.is('a')) {
      e.stopPropagation();
    }
  }

  function keyboardHandler(e) {
    if (e.which === 27) { // esc key
      if ($featureModal.hasClass('visible')) {
        closeHandler();
      }
    }
  }

  function handleTouchLock(e) {
    e.preventDefault();
  }

  function layout() {
    var $featureModal = $('.acr-feature-modal');

    if (!$featureModal.hasClass('visible')) {
      return;
    }

    // Disable scrolling.
    document.addEventListener('touchmove', handleTouchLock, { passive: false });

    $body.addClass('modal-open');
  }

  function waitImage() {
    if ($featureModal.find('img').length) {
      var src;
      var srcset;
      var breakPImages;
      var image = new Image();
      var bpCurrent = getCurrentBreakpoint();

      switch (bpCurrent) {
        case 'sm': breakPImages = $featureModal.find('source[media|="(min-width: 550px)"]');
          break;
        case 'lg': breakPImages = $featureModal.find('source[media|="(min-width: 1024px)"]');
          break;
        case 'xl': breakPImages = $featureModal.find('source[media|="(min-width: 1400px)"]');
          break;
        default: breakPImages = $featureModal.find('img');
          break;
      }

      srcset = breakPImages.attr('srcset') || breakPImages.attr('data-srcset');

      src = srcset.split(',');
      src = src[0];

      $featureModal.find('img').attr('src', src);

      image.onload = function () {
        layout();

        Acr.Disclaimer.init();
      };

      image.src = src;
    }
  }

  function getCurrentBreakpoint() {
    var size = 'xs';
    var width = window.innerWidth;

    if (width < Constants.breakpoints.sm) {
      size = 'xs';
    } else if (width < Constants.breakpoints.lg) {
      size = 'sm';
    } else if (width < Constants.breakpoints.xl) {
      size = 'lg';
    } else {
      size = 'xl';
    }

    return size;
  }

  function init() {
    $body = $('body');
    $featureModal = $('.acr-feature-modal');
    spinner = $('<div class="animated-spinner-container">'
      + '<div class="animated-spinner"></div></div>');

    attachFetch();
    attachClicks();
    attachKeyboardInput();
    attachResize();

    if (Utility.isSafari()) {
      $featureModal.addClass('is-safari');
    }
  }

  return {
    init: init,
  };
}());
